import axios from 'axios';

// Configure axios to include credentials
axios.defaults.withCredentials = true;

// Use the proxy instead of the full URL
const API_URL = '/api';

// Check if user is authenticated
export const checkAuthStatus = async () => {
  try {
    console.log('Checking auth status...');
    const response = await axios.get(`${API_URL}/auth/user`, { withCredentials: true });
    console.log('Auth status response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error checking auth status:', error);
    
    // If we get a 401, the user is definitely not authenticated
    if (error.response && error.response.status === 401) {
      console.log('User is not authenticated (401 response)');
      return { isAuthenticated: false, user: null };
    }
    
    // For other errors, return not authenticated but don't fail silently
    console.warn('Auth check failed with error:', error.message);
    return { isAuthenticated: false, user: null, error: error.message };
  }
};

// Logout user
export const logout = async () => {
  try {
    await axios.get(`${API_URL}/auth/logout`);
    return { success: true };
  } catch (error) {
    console.error('Error logging out:', error);
    return { success: false, error };
  }
}; 